import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IFacilityItem, IFacilityList} from "../Infrastructure/Interfaces";
import axios from "axios";

const FacilityListInitialState: IFacilityList = {
    loading: true,
    facilityDetailsList: [],
  };

  const ItemInitialState : IFacilityItem ={
    facilityAddressId: 0,
    facilityCode: 0,
    facilityName: '',
    region: '',
    tin: '',
    npi: '',
    lockboxAddress: '',
    lockboxCity: '',
    lockboxState: '',
    lockboxZip: '',
    lockboxPhone: '',
    physicalAddress: '',
    physicalCity: '',
    physicalState: '',
    physicalZip: '',
    efrFacilityName: '',
    availityFacility: '',
    createdBy: '',
    createdOn: '', // ISO date ''
    modifiedBy: '',
    modifiedOn: '', // ISO date string
  }

const FacilityItemSlice = createSlice({
    name:'FacilityItem',
    initialState:{value:ItemInitialState},
    reducers:{
        setFacilityItem:(state,action)=>{
            state.value = action.payload
        }
    }
  })
  
  export const fetchFacilityDetailList = createAsyncThunk(
    'fetchFacilityDetailList',
    async () => {
      const baseurl = process.env.REACT_APP_RRD_OPTIMIZATION_BASE_URL as string;

          return axios.get(`${baseurl}/FacilityAddress`, {
              headers: {
                accept: 'text/plain',
              },
            })
            .then(response => {
              if (response.data.success) {
                return response.data.result;
              }
            });
        }
  );
  
  const FacilityDetailListSlice = createSlice({
    name: 'facilitylist',
    initialState: FacilityListInitialState,
    reducers: {},
    extraReducers: builder => {
      builder.addCase(fetchFacilityDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.facilityDetailsList = action.payload;
      });
      builder.addCase(fetchFacilityDetailList.pending, (state, action) => {
        state.loading = true;
      });
      builder.addCase(fetchFacilityDetailList.rejected, (state, action) => {
        state.loading = false;
        state.facilityDetailsList = [];
      });
    },
  });
  
  export const FacilityListReducer = FacilityDetailListSlice.reducer;
  
  export const {setFacilityItem} = FacilityItemSlice.actions;
  
  export const FacilityItemReducer = FacilityDetailListSlice.reducer;